import * as React from 'react';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { HamburgerTab, SidebarModule } from '../../constants/Enums';
import { DebugTab } from './DebugTab';
import { FileListTab } from './FileListTab';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { BaseHamburgerTabProps } from './BaseHamburgerTab';
import { HelpFaqTab } from './HelpFaqTab';
import { HelpIconsTab } from './HelpIconsTab';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SettingsOptionsTab } from './SettingsOptionsTab';
import { HamburgerNavigation } from './HamburgerNavigation';
import { HelpTab } from './HelpTab';
import { CustomLoginTab } from './CustomLoginTab';
import { SettingTab } from './SettingTab';
import { SettingTabApp } from './SettingTabApp';
import { PconLoginTab } from './PConLoginTab';
import { ImportTab } from './ImportTab';
import { DownloadTab } from './DownloadTab';
import { CustomProductOverviewTab } from './CustomProductOverviewTab';

interface HamburgerMenuProps {
    layoutType: LayoutType;
    hamburgerTab: HamburgerTab | null;
    sidebar: SidebarModule;
    sidebarOrientation: string;
    userLanguage: string;
}

export class HamburgerMenu extends BaseComponent<HamburgerMenuProps, {}> {
    public render(): JSX.Element | null  {
        if (this.props.hamburgerTab != null) {
            if (AppConfigurationStore.getState().inApp && AppConfigurationStore.getState().singleHamburgerTabs) {
                return (
                    <div className={this.getCSSClass()}>
                        <div className="menu-underlay" onClick={this.closeHamburgerMenu}/>
                        {this.getSingleTab()}
                        <SettingsOptionsTab
                            layoutType={this.props.layoutType}
                            position={-1}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                        />
                    </div>
                );
            }
            return (
                <div className={this.getCSSClass()}>
                    <div className="menu-underlay" onClick={this.closeHamburgerMenu}/>
                    {this.leftSide()}
                    <SettingsOptionsTab
                        layoutType={this.props.layoutType}
                        position={(this.props.layoutType !== LayoutType.SMALL ? (this.props.layoutType === LayoutType.DESKTOP ? 2 : 1) : 0)}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                    />
                    {this.rightSide()}
                    {this.thirdTab()}
                </div>
            );
        }
        return null;
    }

    protected closeHamburgerMenu = (): void => {
        ViewSettingsActions.changeHamburger(null);
    };

    protected getTab = (nextToMenu: boolean): JSX.Element | null  => {
        switch (this.props.hamburgerTab) {
            case HamburgerTab.DEBUG:
                return (
                    <DebugTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.FILE_LIST:
                return (
                    <FileListTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.SETTINGS:
                return (
                    AppConfigurationStore.getState().inApp ? (
                        <SettingTabApp
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    ) : (
                        <SettingTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    )
                );
            case HamburgerTab.LOGIN:
                return (
                    <PconLoginTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.CUSTOM_LOGIN:
                return (
                    <CustomLoginTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP:
                return (
                    <HelpTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP_FAQ:
                if (this.props.layoutType === LayoutType.DESKTOP) {
                    return (
                        <HelpTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    );
                }
                return (
                    <HelpFaqTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP_ICONS:
                if (this.props.layoutType === LayoutType.DESKTOP) {
                    return (
                        <HelpTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    );
                }
                return (
                    <HelpIconsTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.IMPORT:
                return (
                    <ImportTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.DOWNLOAD:
                return (
                    <DownloadTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP_PRODUCT_OVERVIEW:
                return (
                    <CustomProductOverviewTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            default:
                if (
                    this.props.layoutType !== LayoutType.DESKTOP ||
                    (AppConfigurationStore.getState().singleHamburgerTabs && AppConfigurationStore.getState().inApp)
                ) {
                    if (nextToMenu) {
                        return (
                            AppConfigurationStore.getState().inApp ? (
                                <SettingTabApp
                                    layoutType={this.props.layoutType}
                                    userLanguage={this.props.userLanguage}
                                    sidebarOrientation={this.props.sidebarOrientation}
                                    position={(nextToMenu ? 1 : 0)}
                                />
                            ) : (
                                <SettingTab
                                    layoutType={this.props.layoutType}
                                    userLanguage={this.props.userLanguage}
                                    sidebarOrientation={this.props.sidebarOrientation}
                                    position={(nextToMenu ? 1 : 0)}
                                />
                            )
                        );
                    }
                    return (
                        <HamburgerNavigation
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    );
                }
        }
        return null;
    };

    protected getSingleTab = (): JSX.Element => {
        const props: BaseHamburgerTabProps = {
            layoutType: this.props.layoutType,
            userLanguage: this.props.userLanguage,
            sidebarOrientation: this.props.sidebarOrientation,
            position: -1
        };
        switch (this.props.hamburgerTab) {
            case HamburgerTab.DEBUG:
                return <DebugTab {...props}/>;
            case HamburgerTab.FILE_LIST:
                return <FileListTab {...props}/>;
            case HamburgerTab.SETTINGS:
                if (!AppConfigurationStore.getState().inApp) {
                    return <SettingTab  {...props}/>;
                }
                return <SettingTabApp {...props}/>;
            case HamburgerTab.LOGIN:
                return <PconLoginTab {...props}/>;
            case HamburgerTab.CUSTOM_LOGIN:
                return <CustomLoginTab {...props}/>;
            case HamburgerTab.HELP:
                return <HelpTab {...props}/>;
            case HamburgerTab.HELP_FAQ:
                if (!AppConfigurationStore.getState().inApp) {
                    return <HelpTab {...props}/>;
                }
                return <HelpFaqTab {...props}/>;
            case HamburgerTab.HELP_ICONS:
                if (!AppConfigurationStore.getState().inApp) {
                    return <HelpTab {...props}/>;
                }
                return <HelpIconsTab {...props}/>;
            case HamburgerTab.IMPORT:
                return <ImportTab {...props} />;
            case HamburgerTab.DOWNLOAD:
                return <DownloadTab {...props}/>;
            case HamburgerTab.HELP_PRODUCT_OVERVIEW:
                return <CustomProductOverviewTab {...props}/>;
            default:
                return <HamburgerNavigation {...props}/>;
        }
    };

    protected getCSSClass: () => string = () => {
        let result: string = 'hamburger-menu';
        if (this.props.sidebarOrientation === 'right') {
            result += ' on-right-side';
        }
        if (this.props.sidebar === SidebarModule.PROJECTS) {
            result += ' full-height';
        }
        if (
            AppConfigurationStore.getState().inApp &&
            AppConfigurationStore.getState().singleHamburgerTabs
        ) {
            result += ' hamburger-menu-single';
        }
        return result;
    };

    protected leftSide(): JSX.Element | null  {
        if (this.props.layoutType !== LayoutType.SMALL) {
            return (
                <HamburgerNavigation
                    layoutType={this.props.layoutType}
                    userLanguage={this.props.userLanguage}
                    sidebarOrientation={this.props.sidebarOrientation}
                    position={0}
                />
            );
        }
        return this.getTab(false);
    }

    protected rightSide(): JSX.Element | null  {
        if (this.props.layoutType !== LayoutType.SMALL) {
            return this.getTab(true);
        }
        return null;
    }

    protected thirdTab(): JSX.Element | null  {
        if (
            AppConfigurationStore.getState().inApp &&
            this.props.layoutType === LayoutType.DESKTOP
        ) {
            switch (this.props.hamburgerTab) {
                case HamburgerTab.HELP_FAQ:
                    return (
                        <HelpFaqTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={2}
                        />
                    );
                case HamburgerTab.HELP_ICONS:
                    return (
                        <HelpIconsTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={2}
                        />
                    );
                default:
                    break;
            }
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerMenu.tsx